import type { FormTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const formItemDark: FormTheme = {
  name: 'Form',
  common: commonDark,
  self
}

export default formItemDark
